(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rk-widerruf-digital"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.rkDigitalBereit) return;
    window.rkDigitalBereit = true;
    const SCHLUESSEL = 'Zustimmung digitale Inhalte';

    // Haken sofort am Warenkorb speichern: Schublade und Warenkorb werden bei jeder Mengenänderung neu
    // gezeichnet und lesen den Stand dann aus cart.attributes. Der Zeitpunkt steht danach auf der Bestellung.
    document.addEventListener('change', (e) => {
      const haken = e.target.closest('.rk-digital__haken');
      if (!haken) return;
      const box = haken.closest('[data-rk-digital]');
      const wert = haken.checked
        ? 'Ja – ausdrücklich zugestimmt am ' +
          new Date().toLocaleString('de-DE', { dateStyle: 'medium', timeStyle: 'short' }) + ' Uhr'
        : '';
      if (haken.checked) haken.value = wert;
      box.classList.remove('rk-digital--fehlt');
      box.querySelector('.rk-digital__fehler').hidden = true;
      fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { [SCHLUESSEL]: wert } }),
      }).catch(() => {});
    });

    // Ohne Haken hält der Browser das Formular an; dann den Hinweis sichtbar machen und hinscrollen.
    document.addEventListener(
      'invalid',
      (e) => {
        if (!e.target.classList || !e.target.classList.contains('rk-digital__haken')) return;
        const box = e.target.closest('[data-rk-digital]');
        box.classList.add('rk-digital--fehlt');
        box.querySelector('.rk-digital__fehler').hidden = false;
        box.scrollIntoView({ block: 'center', behavior: 'smooth' });
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
